"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVisitorConnectionType = void 0;
function getVisitorConnectionType() {
    var _a, _b;
    var connectionType = (_b = (_a = window.navigator) === null || _a === void 0 ? void 0 : _a.connection) === null || _b === void 0 ? void 0 : _b.type;
    if (!connectionType || connectionType === 'unknown')
        return 'unknown';
    if (connectionType === 'cellular')
        return 'mobile';
    return 'non-mobile';
}
exports.getVisitorConnectionType = getVisitorConnectionType;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmlzaXRvckNvbm5lY3Rpb25UeXBlLmpzIiwic291cmNlUm9vdCI6InNyYy8iLCJzb3VyY2VzIjpbInNyYy9saWIvdXRpbHMvdmlzaXRvckNvbm5lY3Rpb25UeXBlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQXVCQSxTQUFnQix3QkFBd0I7O0lBQ3BDLElBQU0sY0FBYyxHQUFHLE1BQUEsTUFBQSxNQUFNLENBQUMsU0FBUywwQ0FBRSxVQUFVLDBDQUFFLElBQUksQ0FBQTtJQUV6RCxJQUFJLENBQUMsY0FBYyxJQUFJLGNBQWMsS0FBSyxTQUFTO1FBQUUsT0FBTyxTQUFTLENBQUE7SUFDckUsSUFBSSxjQUFjLEtBQUssVUFBVTtRQUFFLE9BQU8sUUFBUSxDQUFBO0lBRWxELE9BQU8sWUFBWSxDQUFBO0FBQ3ZCLENBQUM7QUFQRCw0REFPQyJ9